import { Bot, MessageSquare, Network, Plug, Terminal } from "lucide-react";
import type React from "react";

import { m } from "@/paraglide/messages.js";

interface ClientAgentsProps {
  className?: string;
}

/**
 * Bento illustration: buy-side agents plugging in. A grid of cells where the
 * highlighted ones stand for the client-side tools that connect straight into
 * the research layer.
 */
export const ClientAgents: React.FC<ClientAgentsProps> = ({ className = "" }) => {
  const connected: { row: number; col: number; icon: React.ElementType }[] = [
    { row: 0, col: 3, icon: Bot },
    { row: 1, col: 5, icon: MessageSquare },
    { row: 2, col: 3, icon: Terminal },
    { row: 2, col: 7, icon: Network },
    { row: 3, col: 5, icon: Plug },
  ];

  const cellAt = (row: number, col: number) => connected.find((c) => c.row === row && c.col === col);

  return (
    <div
      className={`relative h-full w-full ${className}`}
      role="img"
      aria-label={m.landing_capability_buyside_illustration_alt()}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 scale-180 mt-10">
        {Array.from({ length: 4 }).map((_row, row) => (
          <div key={row} className="flex gap-2">
            {Array.from({ length: 10 }).map((_col, col) => {
              const cell = cellAt(row, col);
              if (!cell) {
                return <div key={col} className="size-[34px] shrink-0 rounded-[9px] border border-border" />;
              }
              const Icon = cell.icon;
              return (
                <div
                  key={col}
                  className="flex size-[34px] shrink-0 items-center justify-center overflow-hidden rounded-[9px] bg-gradient-to-b from-primary to-primary/0 p-px shadow"
                >
                  <div className="flex size-full items-center justify-center rounded-[8px] bg-card">
                    <Icon className="size-[20px] text-primary" />
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};
